export const CLIENT_SEARCH_CRITERIA = [
  { value: 'client', label: 'Nombre' },
  { value: 'cuil', label: 'CUIL' },
  { value: 'phone', label: 'Teléfono' },
  { value: 'secondaryPhone', label: 'Teléfono secundario' },
  { value: 'ticketNumber', label: 'N° de Ticket' },
  { value: 'title', label: 'Título' }
];

export const DEFAULT_CLIENT_SEARCH_CRITERION = 'client';
